import { Location, locationName } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const AiPage = lazy(() => import('@cobliteam/ai'));

const routes = [
  {
    title: locationName[Location.AI],
    path: Location.AI,
    component: AiPage,
    featureFlag: 'aiChat',
  },
];

export default routes;
